<template>
    <div class="card" style="min-height: 450px;">
        <h6 class="card-header text-primary">Manage Menus</h6>
        <div class="card-body">
            <section class="row justify-content-between">
                <!-- Create and Update menu -->
                <div v-if="menuType == 'menu'" class="col-md-5">
                    <MainMenu 
                    :mode="menuMode"
                    :menuData="menuData"
                    @addtomenu="addToMenuList" 
                    @updatemenulist="updateMenuList" 
                    @showcreatemenu="showCreateMenu" 
                    />
                </div>

                <!-- Create and Update Sub-menu -->
                <div v-else class="col-md-5">
                    <SubMenu 
                    :mode="subMenuMode"
                    :subMenuData="subMenuData"
                    :mainMenuId="menuData.menuId"
                    @showupdatemenu="showUpdateMenu"
                    @addtosubmenu="addToSubMenuList" 
                    @updatesubmenulist="updateSubMenuList" 
                    />
                </div>

                <!-- List of Sub-menus table -->
                <div class="col-md-7">
                    <ListSubMenu
                    :rows="subMenuList" 
                    :menuId="menuData.menuId" 
                    :hasSubMenu="menuData.hasSubMenu" 
                    @createsubmenu="createSubMenu"
                    @editsubmenu="editSubMenu"
                    @deletesubmenu="deleteSubMenuModal"
                    />
                </div>
            </section>

            <hr>

            <!-- List of Menus table -->
            <section class=" px-4 mt-4">
                <ListMenu 
                :rows="menuList"
                @editmenu="editMenu" 
                @deletemenu="deleteMenuModal" 
                />
            </section>

            <!-- Modal's section -->
            <section>
                <modal name="menu-delete" class="mt-2" :height="'auto'">
                    <div class="p-3">
                        <h6>Are you sure you want to <b>Delete</b> this Menu</h6> 
                    </div>
                    
                    <div class="row justify-content-end mr-4 pb-3">
                        <button class="btn btn-primary btn-sm px-5 mr-5" @click="$modal.hide('menu-delete')">Cancel</button>

                        <button class="btn btn-danger btn-sm px-5" @click.prevent="deleteMenu()">Proceed</button>
                    </div>
                </modal>
                
                <modal name="sub-menu-delete" class="mt-2" :height="'auto'">
                    <div class="p-3">
                        <h6>Are you sure you want to <b>Delete</b> this Sub-Menu</h6> 
                    </div>
                    
                    <div class="row justify-content-end mr-4 pb-3">
                        <button class="btn btn-primary btn-sm px-5 mr-5" @click="$modal.hide('sub-menu-delete')">Cancel</button>

                        <button class="btn btn-danger btn-sm px-5" @click.prevent="deleteSubMenu()">Proceed</button>
                    </div>
                </modal>

            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MainMenu from './manageLayouts/MainMenu.vue'
import SubMenu from './manageLayouts/SubMenu.vue'
import ListMenu from './manageLayouts/ListMenu.vue'
import ListSubMenu from './manageLayouts/ListSubMenu.vue'

export default {
    name: "ManageMenu",

    components:{
        MainMenu,
        SubMenu,
        ListMenu,
        ListSubMenu,
    },

    data(){
        return {
            menuType: 'menu',
            menuMode: 'create',
            subMenuMode: 'create',
            deleteMenuId: null,
            deleteSubMenuId: null,
            menuList: [],
            subMenuList: [],
            menuData: {},
            subMenuData: {},
        }
    },

    computed: {
        ...mapState(['token']),
        ...mapGetters(['everyItems']),
    },

    mounted(){
        this.getMenuList();
    },

    methods: {
        addToMenuList(menuObj){
            this.menuList.push(menuObj);
        },

        addToSubMenuList(menuObj){
            this.subMenuList.push(menuObj);

            this.showUpdateMenu();
        },

        updateMenuList(menuObj){
            for (let i = 0; i < this.menuList.length; i++) {
                const menu = this.menuList[i];
                if (menu.id == menuObj.menuId) {
                    this.menuList[i].menuName = menuObj.menuName;
                    this.menuList[i].menuUrl = menuObj.menuUrl;
                    this.menuList[i].hasSubMenu = menuObj.hasSubMenu;
                    
                    break;
                }
            }

            if(this.menuData.hasSubMenu == 0){
                this.subMenuList = [];
            }
        },

        updateSubMenuList(menuObj){
            console.log(this.subMenuList)
            for (let i = 0; i < this.subMenuList.length; i++) {
                const menu = this.subMenuList[i];
                if (menu.id == menuObj.id) {
                    this.subMenuList[i].subMenuName = menuObj.subMenuName;
                    this.subMenuList[i].subMenuUrl = menuObj.subMenuUrl;
                    
                    break;
                }
            }

            // show create sub-menu
            this.showUpdateMenu();

            // clear the fields
            this.subMenuData.menuId = null;
            this.subMenuData.id = null;
            this.subMenuData.subMenuName = null;
            this.subMenuData.subMenuUrl = null;
        },

        createSubMenu() {
            this.menuType = 'submenu';
            this.subMenuMode = 'create';
        },
        
        showUpdateMenu() {
            this.menuType = 'menu';
            this.menuMode = 'update';
        },

        showCreateMenu() {
            this.menuType = 'menu';
            this.menuMode = 'create';
            this.subMenuList = [];
        },

        editSubMenu(menuObj) {
            this.subMenuData = {
                id: menuObj.id,
                menuId: menuObj.menuId,
                subMenuName: menuObj.subMenuName,
                subMenuUrl: menuObj.subMenuUrl,
            };

            this.menuType = 'submenu';
            this.subMenuMode = 'update';
        },

        getMenuList(){
            const menuUrl = `${this.$urlAuth}/mainmenu/all`;
            this.$http.get(menuUrl, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then((result) => {
                if(result.data.data.code =='S200'){
                    this.menuList = result.data.data.menus;
                }else{
                    console.log(result.data.data.message)
                    // this.$toastr.e(result.data.data.message);
                }
            }).catch(er =>{
                console.log(er);
                if(er.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e('Internal Server Error');
                }
            })
        },

        editMenu(menuId) {
            const baseU = `${this.$urlAuth}/mainmenu/${menuId}`;
            this.$http.get(baseU, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then((result) => {
                if(result.data.data.code =='S200'){
                    this.menuData = result.data.data.menu;
                    this.subMenuList = result.data.data.submenus;

                    this.menuType = 'menu';
                    this.menuMode = 'update';
                }else{
                    this.$toastr.e(result.data.data.message);
                }
            }).catch(er =>{
                console.log(er);
                this.creating=false;
                if(er.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e(er.message);
                }
            })
        },

        deleteMenuModal(menuId){
            this.deleteMenuId = menuId;
            this.$modal.show('menu-delete')
        },
        
        deleteSubMenuModal(menuId){
            this.deleteSubMenuId = menuId;
            this.$modal.show('sub-menu-delete')
        },

        deleteMenu() {
            const baseU = `${this.$urlAuth}/mainmenu/delete`;
            this.$http.post(baseU, {
                menuId: this.deleteMenuId
            }, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then((result) => {
                if(result.data.data.code =='S200'){
                    this.$modal.hide('menu-delete');

                    this.$toastr.s(result.data.data.message);
                    // find the index of the deleted menu from the menuList and splice it out
                    const dIndex = this.menuList.findIndex(menu => menu.id == this.deleteMenuId);
                    if (dIndex >= 0) {
                        this.menuList.splice(dIndex, 1)
                    }
                }else{
                    this.$toastr.e(result.data.data.message);
                }
            }).catch(er =>{
                console.log(er);
                this.creating=false;
                if(er.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e(er.message);
                }
            })
        },

        deleteSubMenu(){
            const baseU = `${this.$urlAuth}/submenu/delete`;
            this.$http.post(baseU, {
                subMenuId: this.deleteSubMenuId
            }, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then((result) => {
                if(result.data.data.code =='S200'){
                    this.$modal.hide('sub-menu-delete');

                    this.$toastr.s(result.data.data.message);
                    // find the index of the deleted menu from the menuList and splice it out
                    const dIndex = this.subMenuList.findIndex(menu => menu.id == this.deleteSubMenuId);
                    if (dIndex >= 0) {
                        this.subMenuList.splice(dIndex, 1)
                    }
                }else{
                    this.$toastr.e(result.data.data.message);
                }
            }).catch(er =>{
                console.log(er);
                this.creating=false;
                if(er.message == 'Network Error'){
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                }else{
                    this.$toastr.e(er.message);
                }
            })
        },
    },
}
</script>